// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Sibling imports
const collectionSelectModalActions = require('./actions')
const CollectionSelectModal = require('./component-dumb')
const selectors = require('./selectors')

function mapStateToProps(state) {
  if (
    !selectors.isVisible(state) ||
    selectors.isContentAddModalVisible(state) ||
    selectors.isLightweightModalVisible(state)
  ) {
    return { isVisible: false }
  }
  return {
    // Flags
    isArticleFailed: selectors.isArticleFailed(state),
    isArticleLoaded: selectors.isArticleLoaded(state),
    isCreateButtonDisabled: selectors.isCreatePending(state),
    isCreateButtonVisible: selectors.canCreateFromFilter(state),
    isCollectionsFailed: selectors.isCollectionsFailed(state),
    isCollectionsLoaded: selectors.isCollectionsLoaded(state),
    isFilteredCollectionsEmpty: selectors.isFilteredCollectionsEmpty(state),
    isUnfilteredCollectionsEmpty: selectors.isUnfilteredCollectionsEmpty(state),
    isUnmixDisabled: selectors.isUnmixPending(state),
    isUnmixButtonVisible: selectors.isArticleUnmixable(state),
    isUnmixPromptVisible: selectors.isUnmixPromptVisible(state),
    isVisible: true,
    // Values
    article: selectors.article(state),
    collections: selectors.filteredCollections(state),
    filterText: selectors.filterText(state)
  }
}

const mapDispatchToProps = {
  onDismiss: collectionSelectModalActions.hide,
  onCreateClick: collectionSelectModalActions.createCollectionFromFilter,
  onCollectionClick: collectionSelectModalActions.toggleCollection,
  onFilterTextChange: collectionSelectModalActions.setFilterText,
  onRetryClick: collectionSelectModalActions.fetch,
  onUnmixClick: collectionSelectModalActions.showUnmixPrompt,
  onUnmixPromptCancel: collectionSelectModalActions.cancelUnmix,
  onUnmixPromptConfirm: collectionSelectModalActions.confirmUnmix
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      CollectionSelectModal
    )
  )
)
